import { render, staticRenderFns } from "./DiscountCodeUsagesTable.vue?vue&type=template&id=11012bc1&scoped=true&"
import script from "./DiscountCodeUsagesTable.vue?vue&type=script&lang=js&"
export * from "./DiscountCodeUsagesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11012bc1",
  null
  
)

export default component.exports